import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { App as AntdApp } from 'antd'
import { useEffect } from 'react'
import { BrowserRouter } from 'react-router-dom'
import { ConfigProvider } from './providers/config-provider/ui/config-provider'
import { ErrorBoundary } from './providers/error-boundary'
import { MiniAppProvider } from './providers/miniapp-provider/ui/miniapp-provider'
import { AppRouter } from './providers/router'
import { ThemeProvider } from './providers/theme-provider'
import './styles/index.scss'

const queryClient = new QueryClient()

declare global {
    interface Window {
        Telegram: {
            WebApp: {
                expand: () => void
                enableClosingConfirmation: () => void
                BackButton: {
                    hide: () => void
                }
            }
        }
    }
}

export const App = () => {
    useEffect(() => {
        const setVh = () => {
            if (window.visualViewport) {
                document.documentElement.style.setProperty('--vh', `${window.visualViewport.height * 0.01}px`)
            } else {
                document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`)
            }
        }

        setVh()
        window.visualViewport?.addEventListener('resize', setVh)
        return () => window.visualViewport?.removeEventListener('resize', setVh)
    }, [])
    return (
        <QueryClientProvider client={queryClient}>
            <BrowserRouter>
                <ThemeProvider>
                    <ConfigProvider>
                        <AntdApp>
                            <ErrorBoundary>
                                <MiniAppProvider>
                                    <AppRouter />
                                </MiniAppProvider>
                            </ErrorBoundary>
                        </AntdApp>
                    </ConfigProvider>
                </ThemeProvider>
            </BrowserRouter>
            {/* <ReactQueryDevtools initialIsOpen={false} /> */}
        </QueryClientProvider>
    )
}
